import { useEffect, useRef } from 'react';

// This effect fires clean up function either after component's lifecycle ends
// or if user closes browser or page, latter functionality limited on mobile devices
export const useCleanup = (cleanupFunction: () => void, deps: any[]) => {
  const componentWillUnmount = useRef(false);

  useEffect(
    () => () => {
      componentWillUnmount.current = true;
    },
    []
  );

  useEffect(() => {
    window.addEventListener('pagehide', cleanupFunction);
    return () => {
      window.removeEventListener('pagehide', cleanupFunction);
      componentWillUnmount.current && cleanupFunction();
    };
  }, deps);
};
